// 答案编码/解码工具
// 10题，每题4选项(0-3)，用2bit存储 = 20bit

// 自定义字符集，避免混淆字符(0/O, 1/I/l)
const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export function encodeAnswers(answers) {
  if (!answers || answers.length !== 10) return null;
  
  // 将10个答案(每个0-3)打包成20bit
  let bits = 0;
  answers.forEach((ans, i) => {
    bits |= (ans.optionIndex & 0x3) << (i * 2);
  });
  
  // 转换为5字符的代码 (每字符5bit = 25bit > 20bit)
  let code = '';
  for (let i = 0; i < 4; i++) {
    code += CHARS[(bits >> (i * 5)) & 0x1F];
  }
  return code;
}

export function decodeAnswers(code) {
  if (!code || code.length !== 4) return null;
  
  try {
    let bits = 0;
    for (let i = 0; i < 4; i++) {
      const idx = CHARS.indexOf(code[i].toUpperCase());
      if (idx === -1) return null;
      bits |= idx << (i * 5);
    }
    
    // 解包为10个答案
    const optionIndices = [];
    for (let i = 0; i < 10; i++) {
      optionIndices.push((bits >> (i * 2)) & 0x3);
    }
    return optionIndices;
  } catch {
    return null;
  }
}

// 从选项索引重建得分
export function rebuildScores(optionIndices, questions) {
  const scores = {};
  optionIndices.forEach((optIdx, qIdx) => {
    if (questions[qIdx] && questions[qIdx].options[optIdx]) {
      const opt = questions[qIdx].options[optIdx];
      scores[opt.archetype] = (scores[opt.archetype] || 0) + opt.weight;
    }
  });
  return scores;
}

// 获取主要原型
export function getTopArchetypes(scores, count = 3) {
  return Object.entries(scores)
    .sort((a, b) => b[1] - a[1])
    .slice(0, count)
    .map(([key, score]) => ({ key, score }));
}
